import { hasCommitteeOnlyAccess } from './uruguayRoles';
import { routes } from '../routes/routePaths';

export function resolveRouteForRoles(roles: string[], intended: string): string {
  return hasCommitteeOnlyAccess(roles) ? routes.committee : intended;
}
